<template>
  <!-- Cabeçalho da página (architecture/frontend-layout.md): título/subtítulo à esquerda, ações da página à direita -->
  <div class="header p-2 d-flex justify-space-between align-center flex-wrap" data-testid="dirbi-cabecalho">
    <div class="title">
      <h3 class="h3 bold mb-n2">DIRBI</h3>
      <span class="subtitle-2 grey--text text--darken-1" data-testid="dirbi-subtitulo">
        {{ subtitulo }}
      </span>
    </div>
    <div v-if="$slots.default" class="actions d-flex flex-row align-center">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "dirbi-cabecalho",
  props: {
    subtitulo: {
      type: String,
      default: ""
    }
  }
};
</script>
